<template>
  <component :is="component" :filterData="filterData" :sortData="sortData" v-if="component"/>
</template>

<script>
export default {
  name: "CompetitionFilterLink",
  mixins: [],
  components: {
  },
  inject: [],
  provide() {
    return{

    }
  },
  props: {
    filterLayout: {},
      filterData: {default: () => {}},
      sortData: {default: () => {}}
  },
  data() {
    return{
      component: null,
    }
  },
  beforeRouterEnter() {},
  created() {
  },
  mounted() {
    this.loader()
        .then(() => {
          this.component = () => this.loader()
        })
        .catch(() => {
          this.component = () => import('@/template/competition/filter/CompetitionFilterDefaultLayout')
        })

  },
  beforeDestroy() {
  },
  destroyed() {},
  computed: {
    loader() {
      if (!this.filterLayout) {
        return null
      }
      return () => import(`@/template/competition/filter/${this.filterLayout}`)
    },
  },
  methods:{

  },
  watch: {

  },
}
</script>

<style scoped>

</style>
